// extracted by mini-css-extract-plugin
export var heading3 = "commitmentCard-module--heading3--6906e";
export var paper = "commitmentCard-module--paper--7fd33";